module.exports = __webpack_public_path__ + "img/back_arrow_blue.11e9d64b.svg";